/* istanbul ignore file */
/* eslint-disable */
import {
  MotiveringCompleetOutput,
  InkomensanalyseResultaatAanvrager,
  InkomensanalyseResultaat,
  InkomensanalyseConclusieOpties
} from "../../../../.generated/rapportage/rapportagetypes";
import { InkomensanalyseProps } from "../werkloosheid-drawer";
import { OverlijdenProps } from "../overlijden-drawer";
import { ArbeidsongeschiktheidProps } from "../arbeidsongeschiktheid-drawer";
import { PensioenDataProps } from "../pensioen-drawer";
import { optellen } from "adviesbox-shared";
import { AanvragerKeuze } from "../../../../shared/types";

function getInkomstenPeriodes(motiveringDl: MotiveringCompleetOutput, partnerIsSelected: boolean) {
  const periodResults = motiveringDl.motiveringInkomensanalyse?.resultaten;

  const aanvrager1PeriodData: (InkomensanalyseResultaatAanvrager | null | undefined)[] = [
    undefined,
    undefined,
    undefined
  ];
  const aanvrager2PeriodData: (InkomensanalyseResultaatAanvrager | null | undefined)[] = [
    undefined,
    undefined,
    undefined
  ];
  const periodConclusies: (InkomensanalyseConclusieOpties | null)[] = [];

  if (periodResults) {
    for (let i = 0; i < 3; i++) {
      // Assuming max 3 periods
      const currentPeriod: InkomensanalyseResultaat | undefined = periodResults[i];
      if (currentPeriod) {
        aanvrager1PeriodData[i] = partnerIsSelected ? currentPeriod.aanvrager2 : currentPeriod.aanvrager1;
        aanvrager2PeriodData[i] = partnerIsSelected ? currentPeriod.aanvrager1 : currentPeriod.aanvrager2;
        periodConclusies[i] = currentPeriod.conclusie;
      }
    }
  }

  return {
    aanvragerInkomstenPeriodeEerst: aanvrager1PeriodData[0],
    aanvragerInkomstenPeriodeTweede: aanvrager1PeriodData[1],
    aanvragerInkomstenPeriodeDerde: aanvrager1PeriodData[2],
    partnerInkomstenPeriodeEerste: aanvrager2PeriodData[0],
    partnerInkomstenPeriodeTweede: aanvrager2PeriodData[1],
    partnerInkomstenPeriodeDerde: aanvrager2PeriodData[2],
    conclusiePeriodeEerste: periodConclusies[0],
    conclusiePeriodeTweede: periodConclusies[1],
    conclusiePeriodeDerde: periodConclusies[2]
  };
}

export function mapMotiveringWWToInkomensanalyseProps(
  motiveringDl: MotiveringCompleetOutput,
  aanvragerKeuze: AanvragerKeuze
): InkomensanalyseProps {
  const {
    aanvragerInkomstenPeriodeEerst,
    aanvragerInkomstenPeriodeTweede,
    aanvragerInkomstenPeriodeDerde,
    partnerInkomstenPeriodeEerste,
    partnerInkomstenPeriodeTweede,
    partnerInkomstenPeriodeDerde,
    conclusiePeriodeEerste
  } = getInkomstenPeriodes(motiveringDl, aanvragerKeuze === AanvragerKeuze.Aanvrager2);

  const normGegevens = motiveringDl.normGegevens;

  if (
    !aanvragerInkomstenPeriodeEerst ||
    !normGegevens ||
    motiveringDl.totaalHuidigBrutoJaarinkomenBedrag === undefined
  ) {
    return {} as InkomensanalyseProps;
  }

  return {
    titel: "Inkomensanalyse bij werkloosheid",
    totaalHuidigBrutoJaarinkomenBedrag: motiveringDl.totaalHuidigBrutoJaarinkomenBedrag,
    conclusie: conclusiePeriodeEerste || "",
    inkomensanalyseResultaten: motiveringDl.motiveringInkomensanalyse?.resultaten || [],
    nbi: motiveringDl.motiveringInkomensanalyse?.nbiOverzichten?.["1"]?.jaren || [],
    motiveringInkomensanalyse: motiveringDl.motiveringInkomensanalyse || null,
    nbiVoetnoot: motiveringDl.motiveringInkomensanalyse?.nbiOverzicht?.voetnoot?.voetnoot || "",
    nbiWeergeven: false,
    inkomensData: {
      naamPersoon:
        aanvragerKeuze === AanvragerKeuze.Aanvrager2
          ? motiveringDl.klantNaamPartner || "Partner"
          : motiveringDl.klantNaamAanvrager || "Aanvrager",
      beleggingInkomenEerste:
        (aanvragerInkomstenPeriodeEerst.beleggingenBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst.beleggingenBruteringBedrag || 0),
      beleggingInkomenTweede:
        (aanvragerInkomstenPeriodeTweede?.beleggingenBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0),
      beleggingInkomenDerde:
        (aanvragerInkomstenPeriodeDerde?.beleggingenBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0),
      verhuurInkomenEerste:
        (aanvragerInkomstenPeriodeEerst.verhuurBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst.verhuurBruteringBedrag || 0),
      verhuurInkomenTweede:
        (aanvragerInkomstenPeriodeTweede?.verhuurBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0),
      verhuurInkomenDerde:
        (aanvragerInkomstenPeriodeDerde?.verhuurBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0),
      inkomenOverigEerste:
        (aanvragerInkomstenPeriodeEerst?.inkomstenOverigBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.inkomstenOverigBruteringBedrag || 0),
      inkomenOverigTweede:
        (aanvragerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0),
      inkomenOverigDerde:
        (aanvragerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0),
      eersteUitkering: aanvragerInkomstenPeriodeEerst.wwUitkeringBedrag,
      tweedeUitkering: aanvragerInkomstenPeriodeTweede?.wwUitkeringBedrag || 0,
      restinkomen: aanvragerInkomstenPeriodeEerst?.restInkomenBedrag,
      aantalmaandenWwUitkering: motiveringDl.motiveringInkomensanalyse?.aanvrager1?.aantalMaandenWwUitkering || 0,
      totaalEerste: motiveringDl.totaalBrutoInkomenBedrag || 0,
      totaalTweede: motiveringDl.totaalBrutoInkomenBedrag || 0,
      totaalNa: motiveringDl.totaalBrutoInkomenBedrag || 0,
      inkomensverliesEerste: Math.max(
        optellen([
          (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 0) / 12 -
            ((aanvragerInkomstenPeriodeEerst?.restInkomenBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.beleggingenBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.beleggingenBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.verhuurBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.verhuurBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.inkomstenOverigBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.inkomstenOverigBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.wwUitkeringBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.beleggingenBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.beleggingenBruteringBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.verhuurBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.verhuurBruteringBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.inkomstenOverigBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.inkomstenOverigBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.woonlastenverzekeringBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.woonlastenverzekeringBedrag || 0)) /
              12
        ]) || 0,
        0
      ),
      inkomensverliesTweede: Math.max(
        optellen([
          (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 0) / 12 -
            ((aanvragerInkomstenPeriodeTweede?.restInkomenBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.beleggingenBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.verhuurBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.wwUitkeringBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.restInkomenBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.beleggingenBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.verhuurBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBedrag || 0)) /
              12
        ]) || 0,
        0
      ),
      inkomensverliesDerde: Math.max(
        optellen([
          (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 0) / 12 -
            ((aanvragerInkomstenPeriodeDerde?.restInkomenBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.beleggingenBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.verhuurBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.wwUitkeringBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.restInkomenBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.beleggingenBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.verhuurBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBedrag || 0)) /
              12
        ]) || 0,
        0
      ),
      totaalInkomen: optellen([
        aanvragerInkomstenPeriodeEerst?.restInkomenBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.wwUitkeringBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.woonlastenverzekeringBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.woonlastenverzekeringBruteringBedrag || 0,
        partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0
      ]),
      totaalInkomenTweede: optellen([
        aanvragerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.wwUitkeringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBruteringBedrag || 0,
        partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0
      ]),
      totaalInkomenDerde: optellen([
        aanvragerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.wwUitkeringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBruteringBedrag || 0,
        partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0
      ]),
      woonlastenEerstePeriode:
        (aanvragerInkomstenPeriodeEerst.woonlastenverzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst.woonlastenverzekeringBruteringBedrag || 0),
      woonlastenTweedePeriode:
        (aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBruteringBedrag || 0),
      woonlastenDerdePeriode:
        (aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBruteringBedrag || 0),
      inkomenPartnerEerstePeriode: partnerInkomstenPeriodeEerste?.restInkomenBedrag || null,
      inkomenPartnerTweedePeriode: partnerInkomstenPeriodeTweede?.restInkomenBedrag || null,
      inkomenPartnerDerdePeriode: partnerInkomstenPeriodeDerde?.restInkomenBedrag || null
    },
    inkomensDataPartner: {
      naamPersoon:
        aanvragerKeuze === AanvragerKeuze.Aanvrager2
          ? motiveringDl.klantNaamPartner || "Partner"
          : motiveringDl.klantNaamAanvrager || "Aanvrager",
      beleggingInkomenEerste:
        (partnerInkomstenPeriodeEerste?.beleggingenBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.beleggingenBruteringBedrag || 0),
      beleggingInkomenTweede:
        (partnerInkomstenPeriodeTweede?.beleggingenBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0),
      beleggingInkomenDerde:
        (partnerInkomstenPeriodeDerde?.beleggingenBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0),
      verhuurInkomenEerste:
        (partnerInkomstenPeriodeEerste?.verhuurBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.verhuurBruteringBedrag || 0),
      verhuurInkomenTweede:
        (partnerInkomstenPeriodeTweede?.verhuurBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0),
      verhuurInkomenDerde:
        (partnerInkomstenPeriodeDerde?.verhuurBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0),
      inkomenOverigEerste:
        (partnerInkomstenPeriodeEerste?.inkomstenOverigBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.inkomstenOverigBruteringBedrag || 0),
      inkomenOverigTweede:
        (partnerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0),
      inkomenOverigDerde:
        (partnerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0),
      eersteUitkering: partnerInkomstenPeriodeEerste?.wwUitkeringBedrag || null,
      tweedeUitkering: partnerInkomstenPeriodeEerste?.wwUitkeringBedrag || null,
      restinkomen: partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0,
      aantalmaandenWwUitkering: motiveringDl.motiveringInkomensanalyse?.aanvrager2?.aantalMaandenWwUitkering || 0,
      totaalEerste: motiveringDl.totaalBrutoInkomenBedrag || 0,
      totaalTweede: motiveringDl.totaalBrutoInkomenBedrag || 0,
      totaalNa: motiveringDl.totaalBrutoInkomenBedrag || 0,
      tekortEerste: normGegevens?.tekortGewenstBrutoInkomenBedrag,
      tekortTweede: 0,
      tekortNa: normGegevens?.tekortGewenstBrutoInkomenBedrag,
      totaalInkomen: null,
      totaalInkomenTweede: optellen([
        partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0,
        partnerInkomstenPeriodeEerste?.wwUitkeringBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.restInkomenBedrag || 0
      ]),
      totaalInkomenDerde: optellen([
        partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.restInkomenBedrag || 0
      ])
    },
    jaarlijkseAnalyse: {
      gemiddeldeInkomen: motiveringDl.totaalBrutoInkomenGemiddeldBedrag || 0,
      gewenstInkomen: normGegevens?.gewenstBrutoInkomenBedrag,
      gewenstInkomenPercentage:
        ((normGegevens.gewenstBrutoInkomenBedrag || 1) / (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 1)) * 100,
      maandelijksTekort: normGegevens.gewenstBrutoInkomenBedrag
        ? Math.max(normGegevens.gewenstBrutoInkomenBedrag - (motiveringDl.totaalBrutoInkomenGemiddeldBedrag || 0), 0) /
          12
        : 0
    },
    financieleGegevens: {
      toegestaneLast: normGegevens?.toegestaneLastBedrag,
      werkelijkeBrutoLast: normGegevens?.werkelijkeLastBedrag,
      tekortWerkelijkeBrutolast: (normGegevens?.toegestaneLastBedrag || 0) - (normGegevens?.werkelijkeLastBedrag || 0),
      maximaleHypotheek: normGegevens?.maximaleHypotheekBedrag,
      hypotheekSaldo: normGegevens?.hypotheeksaldoBedrag,
      overschrijding: Math.min(
        (normGegevens?.maximaleHypotheekBedrag || 0) - (normGegevens?.hypotheeksaldoBedrag || 0),
        0
      ),
      benodigdInkomenHypotheek: normGegevens.benodigdInkomenBedrag ? normGegevens.benodigdInkomenBedrag / 12 : 0,
      tekortOpInkomen: normGegevens.tekortBenodigInkomenBedrag ? normGegevens.tekortBenodigInkomenBedrag / 12 : 0
    },
    voetnoten: motiveringDl.toelichtingRegels || [],
    benodigdKapitaal: motiveringDl.benodigdKapitaal?.bedrag || 0,
    benodigdKapitaalOmschrijving: motiveringDl.benodigdKapitaal?.omschrijving || ""
  };
}

export function mapMotiveringAOToInkomensanalyseProps(
  motiveringDl: MotiveringCompleetOutput,
  aanvragerKeuze: AanvragerKeuze
): ArbeidsongeschiktheidProps {
  const {
    aanvragerInkomstenPeriodeEerst,
    aanvragerInkomstenPeriodeTweede,
    aanvragerInkomstenPeriodeDerde,
    partnerInkomstenPeriodeEerste,
    partnerInkomstenPeriodeTweede,
    partnerInkomstenPeriodeDerde,
    conclusiePeriodeEerste,
    conclusiePeriodeTweede,
    conclusiePeriodeDerde
  } = getInkomstenPeriodes(motiveringDl, aanvragerKeuze === AanvragerKeuze.Aanvrager2);

  const scenarioGegevens = motiveringDl.scenarioGegevens;
  const normGegevens = motiveringDl.normGegevens;

  if (
    !aanvragerInkomstenPeriodeEerst ||
    !normGegevens ||
    motiveringDl.totaalHuidigBrutoJaarinkomenBedrag === undefined ||
    !scenarioGegevens
  ) {
    return {} as ArbeidsongeschiktheidProps;
  }

  return {
    nbiWeergeven: false,
    inkomensanalyseResultaten: motiveringDl.motiveringInkomensanalyse?.resultaten || [],
    titel: "Inkomensanalyse bij arbeidsongeschiktheid",
    totaalHuidigBrutoJaarinkomenBedrag: motiveringDl.totaalHuidigBrutoJaarinkomenBedrag,
    motiveringInkomensanalyse: motiveringDl.motiveringInkomensanalyse,
    conclusieEerste: conclusiePeriodeEerste || "",
    conclusieTweede: conclusiePeriodeTweede || "",
    conclusieDerde: conclusiePeriodeDerde || "",
    nbiVoetnoot: motiveringDl.motiveringInkomensanalyse?.nbiOverzicht?.voetnoot?.voetnoot || "",
    nbi: motiveringDl.motiveringInkomensanalyse?.nbiOverzichten?.["1"]?.jaren || [],
    inkomensData: {
      naamPersoon:
        aanvragerKeuze === AanvragerKeuze.Aanvrager2
          ? motiveringDl.klantNaamPartner || "Partner"
          : motiveringDl.klantNaamAanvrager || "Aanvrager",
      inkomenAanvragerEerstePeriode: aanvragerInkomstenPeriodeEerst.restInkomenBedrag,
      inkomenAanvragerTweedePeriode: aanvragerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
      inkomenAanvragerDerdePeriode: aanvragerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
      inkomenPartnerEerstePeriode: partnerInkomstenPeriodeEerste?.restInkomenBedrag || null,
      inkomenPartnerTweedePeriode: partnerInkomstenPeriodeTweede?.restInkomenBedrag || null,
      inkomenPartnerDerdePeriode: partnerInkomstenPeriodeDerde?.restInkomenBedrag || null,
      beleggingInkomenEerste:
        (aanvragerInkomstenPeriodeEerst?.beleggingenBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.beleggingenBruteringBedrag || 0),
      beleggingInkomenTweede:
        (aanvragerInkomstenPeriodeTweede?.beleggingenBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0),
      beleggingInkomenDerde:
        (aanvragerInkomstenPeriodeDerde?.beleggingenBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0),
      beleggingInkomenPartnerEerste:
        (partnerInkomstenPeriodeEerste?.beleggingenBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.beleggingenBruteringBedrag || 0),
      beleggingInkomenPartnerTweede:
        (partnerInkomstenPeriodeTweede?.beleggingenBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0),
      beleggingInkomenPartnerDerde:
        (partnerInkomstenPeriodeDerde?.beleggingenBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0),
      verhuurInkomenEerste:
        (aanvragerInkomstenPeriodeEerst?.verhuurBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.verhuurBruteringBedrag || 0),
      verhuurInkomenTweede:
        (aanvragerInkomstenPeriodeTweede?.verhuurBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0),
      verhuurInkomenDerde:
        (aanvragerInkomstenPeriodeDerde?.verhuurBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0),
      verhuurInkomenPartnerEerste:
        (partnerInkomstenPeriodeEerste?.verhuurBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.verhuurBruteringBedrag || 0),
      verhuurInkomenPartnerTweede:
        (partnerInkomstenPeriodeTweede?.verhuurBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0),
      verhuurInkomenPartnerDerde:
        (partnerInkomstenPeriodeDerde?.verhuurBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0),
      inkomenOverigEerste:
        (aanvragerInkomstenPeriodeEerst?.inkomstenOverigBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.inkomstenOverigBruteringBedrag || 0),
      inkomenOverigTweede:
        (aanvragerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0),
      inkomenOverigDerde:
        (aanvragerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0),
      inkomenOverigPartnerEerste:
        (partnerInkomstenPeriodeEerste?.inkomstenOverigBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.inkomstenOverigBruteringBedrag || 0),
      inkomenOverigPartnerTweede:
        (partnerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0),
      inkomenOverigPartnerDerde:
        (partnerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0),
      werkgeverspensioenEerstePeriode:
        (aanvragerInkomstenPeriodeEerst?.werkgeverspensioenBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.werkgeverspensioenBedrag || 0),
      werkgeverspensioenTweedePeriode:
        (aanvragerInkomstenPeriodeTweede?.werkgeverspensioenBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.werkgeverspensioenBedrag || 0),
      werkgeverspensioenDerdePeriode:
        (aanvragerInkomstenPeriodeDerde?.werkgeverspensioenBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.werkgeverspensioenBedrag || 0),
      invaliditeitspensioenEerstePeriode:
        (aanvragerInkomstenPeriodeEerst.invaliditeitspensioenBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.invaliditeitspensioenBedrag || 0),
      invaliditeitspensioenTweedePeriode:
        (aanvragerInkomstenPeriodeTweede?.invaliditeitspensioenBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.invaliditeitspensioenBedrag || 0),
      invaliditeitspensioenDerdePeriode:
        (aanvragerInkomstenPeriodeDerde?.invaliditeitspensioenBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.invaliditeitspensioenBedrag || 0),
      wgaUitkeringAanvragerEerstePeriode:
        (aanvragerInkomstenPeriodeEerst.wgaUitkeringBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.wgaUitkeringBedrag || 0),
      wgaUitkeringAanvragerTweedePeriode:
        (aanvragerInkomstenPeriodeTweede?.wgaUitkeringBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.wgaUitkeringBedrag || 0),
      wgaUitkeringAanvragerDerdePeriode:
        (aanvragerInkomstenPeriodeDerde?.wgaUitkeringBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.wgaUitkeringBedrag || 0),
      wgaGatVerzekeringEerstePeriode:
        (aanvragerInkomstenPeriodeEerst.wgaGatVerzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.wgaGatVerzekeringBruteringBedrag || 0),
      wgaGatVerzekeringTweedePeriode:
        (aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBruteringBedrag || 0),
      wgaGatVerzekeringDerdePeriode:
        (aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBruteringBedrag || 0),
      wiaExcedentVerzekeringEerstePeriode:
        (aanvragerInkomstenPeriodeEerst.wiaExcedentVerzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.wiaExcedentVerzekeringBruteringBedrag || 0),
      wiaExcedentVerzekeringTweedePeriode:
        (aanvragerInkomstenPeriodeTweede?.wiaExcedentVerzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.wiaExcedentVerzekeringBruteringBedrag || 0),
      wiaExcedentVerzekeringDerdePeriode:
        (aanvragerInkomstenPeriodeDerde?.wiaExcedentVerzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.wiaExcedentVerzekeringBruteringBedrag || 0),
      arbeidsongeschiktheidsverzekeringEerstePeriode:
        (aanvragerInkomstenPeriodeEerst.arbeidsongeschiktheidsverzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0),
      arbeidsongeschiktheidsverzekeringTweedePeriode:
        (aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0),
      arbeidsongeschiktheidsverzekeringDerdePeriode:
        (aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0),
      totaalInkomenEerstePeriode: optellen([
        aanvragerInkomstenPeriodeEerst.wgaUitkeringBedrag,
        aanvragerInkomstenPeriodeEerst.wgaGatVerzekeringBedrag || 0,
        aanvragerInkomstenPeriodeEerst.wgaGatVerzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeEerst.wiaExcedentVerzekeringBedrag || 0,
        aanvragerInkomstenPeriodeEerst.wiaExcedentVerzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeEerst.arbeidsongeschiktheidsverzekeringBedrag || 0,
        aanvragerInkomstenPeriodeEerst.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.woonlastenverzekeringBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.woonlastenverzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeEerst.restInkomenBedrag || 0,
        partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.ivaUitkeringBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.invaliditeitspensioenBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.werkgeverspensioenBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.beleggingenBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.beleggingenBruteringBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.verhuurBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.verhuurBruteringBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.inkomstenOverigBedrag || 0,
        aanvragerInkomstenPeriodeEerst?.inkomstenOverigBruteringBedrag || 0,
        partnerInkomstenPeriodeEerste?.beleggingenBedrag || 0,
        partnerInkomstenPeriodeEerste?.beleggingenBruteringBedrag || 0,
        partnerInkomstenPeriodeEerste?.verhuurBedrag || 0,
        partnerInkomstenPeriodeEerste?.verhuurBruteringBedrag || 0,
        partnerInkomstenPeriodeEerste?.inkomstenOverigBedrag || 0,
        partnerInkomstenPeriodeEerste?.inkomstenOverigBruteringBedrag || 0
      ]),
      totaalInkomenTweedePeriode: optellen([
        aanvragerInkomstenPeriodeTweede?.wgaUitkeringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.wiaExcedentVerzekeringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.wiaExcedentVerzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
        partnerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.ivaUitkeringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.invaliditeitspensioenBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.werkgeverspensioenBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.beleggingenBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.verhuurBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0,
        aanvragerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0,
        partnerInkomstenPeriodeTweede?.beleggingenBedrag || 0,
        partnerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0,
        partnerInkomstenPeriodeTweede?.verhuurBedrag || 0,
        partnerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0,
        partnerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0,
        partnerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0
      ]),
      totaalInkomenDerdePeriode: optellen([
        aanvragerInkomstenPeriodeDerde?.wgaUitkeringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.wiaExcedentVerzekeringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.wiaExcedentVerzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBruteringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
        partnerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.ivaUitkeringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.invaliditeitspensioenBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.werkgeverspensioenBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.beleggingenBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.verhuurBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0,
        aanvragerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0,
        partnerInkomstenPeriodeDerde?.beleggingenBedrag || 0,
        partnerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0,
        partnerInkomstenPeriodeDerde?.verhuurBedrag || 0,
        partnerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0,
        partnerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0,
        partnerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0
      ]),
      inkomensverliesEerste: Math.max(
        (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 0) / 12 -
          (optellen([
            aanvragerInkomstenPeriodeEerst.wgaUitkeringBedrag,
            aanvragerInkomstenPeriodeEerst.wgaGatVerzekeringBedrag || 0,
            aanvragerInkomstenPeriodeEerst.wgaGatVerzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeEerst.wiaExcedentVerzekeringBedrag || 0,
            aanvragerInkomstenPeriodeEerst.wiaExcedentVerzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeEerst.arbeidsongeschiktheidsverzekeringBedrag || 0,
            aanvragerInkomstenPeriodeEerst.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
            (aanvragerInkomstenPeriodeEerst.woonlastenverzekeringBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.woonlastenverzekeringBedrag || 0),
            (aanvragerInkomstenPeriodeEerst?.beleggingenBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.beleggingenBruteringBedrag || 0),
            (aanvragerInkomstenPeriodeEerst?.verhuurBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.verhuurBruteringBedrag || 0),
            (aanvragerInkomstenPeriodeEerst?.inkomstenOverigBedrag || 0) +
              (aanvragerInkomstenPeriodeEerst?.inkomstenOverigBruteringBedrag || 0),
            aanvragerInkomstenPeriodeEerst?.restInkomenBedrag || 0,
            partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0,
            (partnerInkomstenPeriodeEerste?.beleggingenBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.beleggingenBruteringBedrag || 0),
            (partnerInkomstenPeriodeEerste?.verhuurBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.verhuurBruteringBedrag || 0),
            (partnerInkomstenPeriodeEerste?.inkomstenOverigBedrag || 0) +
              (partnerInkomstenPeriodeEerste?.inkomstenOverigBruteringBedrag || 0),
            aanvragerInkomstenPeriodeEerst?.ivaUitkeringBedrag || 0,
            aanvragerInkomstenPeriodeEerst?.invaliditeitspensioenBedrag || 0,
            aanvragerInkomstenPeriodeEerst?.werkgeverspensioenBedrag || 0
          ]) || 0) /
            12,
        0
      ),
      inkomensverliesTweede: Math.max(
        (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 0) / 12 -
          (optellen([
            aanvragerInkomstenPeriodeTweede?.wgaUitkeringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.wiaExcedentVerzekeringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.wiaExcedentVerzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
            (aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBedrag || 0),
            (aanvragerInkomstenPeriodeTweede?.beleggingenBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0),
            (aanvragerInkomstenPeriodeTweede?.verhuurBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0),
            (aanvragerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0) +
              (aanvragerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0),
            aanvragerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
            partnerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
            (partnerInkomstenPeriodeTweede?.beleggingenBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.beleggingenBruteringBedrag || 0),
            (partnerInkomstenPeriodeTweede?.verhuurBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.verhuurBruteringBedrag || 0),
            (partnerInkomstenPeriodeTweede?.inkomstenOverigBedrag || 0) +
              (partnerInkomstenPeriodeTweede?.inkomstenOverigBruteringBedrag || 0),
            aanvragerInkomstenPeriodeTweede?.ivaUitkeringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.invaliditeitspensioenBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.werkgeverspensioenBedrag || 0
          ]) || 0) /
            12,
        0
      ),
      inkomensverliesDerde: Math.max(
        (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 0) / 12 -
          (optellen([
            aanvragerInkomstenPeriodeDerde?.wgaUitkeringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.wiaExcedentVerzekeringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.wiaExcedentVerzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
            (aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBruteringBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBedrag || 0),
            (aanvragerInkomstenPeriodeDerde?.beleggingenBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0),
            (aanvragerInkomstenPeriodeDerde?.verhuurBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0),
            (aanvragerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0) +
              (aanvragerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0),
            aanvragerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
            partnerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
            (partnerInkomstenPeriodeDerde?.beleggingenBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.beleggingenBruteringBedrag || 0),
            (partnerInkomstenPeriodeDerde?.verhuurBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.verhuurBruteringBedrag || 0),
            (partnerInkomstenPeriodeDerde?.inkomstenOverigBedrag || 0) +
              (partnerInkomstenPeriodeDerde?.inkomstenOverigBruteringBedrag || 0),
            aanvragerInkomstenPeriodeDerde?.ivaUitkeringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.invaliditeitspensioenBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.werkgeverspensioenBedrag || 0
          ]) || 0) /
            12,
        0
      ),
      percentageAoEerste: scenarioGegevens?.percentageArbeidsongeschiktheid || 0,
      percentageAoTweede: scenarioGegevens?.percentageArbeidsongeschiktheidExtra1 || 0,
      percentageAoDerde: scenarioGegevens?.percentageArbeidsongeschiktheidExtra2 || 0,
      ivaUitkeringAanvragerEerstePeriode:
        (aanvragerInkomstenPeriodeEerst?.ivaUitkeringBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.ivaUitkeringBedrag || 0),
      ivaUitkeringAanvragerTweedePeriode:
        (aanvragerInkomstenPeriodeTweede?.ivaUitkeringBedrag || 0) +
        (partnerInkomstenPeriodeTweede?.ivaUitkeringBedrag || 0),
      ivaUitkeringAanvragerDerdePeriode:
        (aanvragerInkomstenPeriodeDerde?.ivaUitkeringBedrag || 0) +
        (partnerInkomstenPeriodeDerde?.ivaUitkeringBedrag || 0),
      woonlastenEerstePeriode:
        (aanvragerInkomstenPeriodeEerst?.woonlastenverzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.woonlastenverzekeringBruteringBedrag || 0),
      woonlastenTweedePeriode:
        (aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeTweede?.woonlastenverzekeringBruteringBedrag || 0),
      woonlastenDerdePeriode:
        (aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBedrag || 0) +
        (aanvragerInkomstenPeriodeDerde?.woonlastenverzekeringBruteringBedrag || 0),
      rvcEerste:
        ((100 - (scenarioGegevens?.percentageArbeidsongeschiktheid || 0)) *
          (scenarioGegevens?.verdiencapaciteitPercentage || 0)) /
        100,
      rvcTweede:
        ((100 - (scenarioGegevens?.percentageArbeidsongeschiktheidExtra1 || 0)) *
          (scenarioGegevens?.verdiencapaciteitPercentageExtra1 || 0)) /
        100,
      rvcDerde:
        ((100 - (scenarioGegevens?.percentageArbeidsongeschiktheidExtra2 || 0)) *
          (scenarioGegevens?.verdiencapaciteitPercentageExtra2 || 0)) /
        100,
      brutoInkomenPartnerEerstePeriode: partnerInkomstenPeriodeEerste?.nettoInkomstenBedrag || 0,
      brutoInkomenPartnerTweedePeriode: motiveringDl.totaalBrutoInkomenBedrag || 0,
      brutoInkomenPartnerDerdePeriode: motiveringDl.totaalBrutoInkomenBedrag || 0
    },
    jaarlijkseAnalyse: {
      gewenstInkomen: normGegevens.gewenstBrutoInkomenBedrag,
      maandelijksTekortEerste: Math.min(
        (optellen([
          aanvragerInkomstenPeriodeEerst.wgaUitkeringBedrag,
          aanvragerInkomstenPeriodeEerst?.wgaGatVerzekeringBedrag || 0,
          aanvragerInkomstenPeriodeEerst?.wgaGatVerzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeEerst?.wiaExcedentVerzekeringBedrag || 0,
          aanvragerInkomstenPeriodeEerst?.wiaExcedentVerzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeEerst?.arbeidsongeschiktheidsverzekeringBedrag || 0,
          aanvragerInkomstenPeriodeEerst?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeEerst?.restInkomenBedrag || 0,
          partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0,
          aanvragerInkomstenPeriodeEerst?.ivaUitkeringBedrag || 0
        ]) || 0) /
          12 -
          (normGegevens.gewenstBrutoInkomenBedrag || 0) / 12,
        0 // min0
      ),
      maandelijksTekortTweede: Math.min(
        (optellen([
          aanvragerInkomstenPeriodeTweede?.wgaUitkeringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.wiaExcedentVerzekeringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.wiaExcedentVerzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
          partnerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.ivaUitkeringBedrag || 0
        ]) || 0) /
          12 -
          (normGegevens.gewenstBrutoInkomenBedrag || 0) / 12,
        0 // min0
      ),
      maandelijksTekortDerde: Math.min(
        (optellen([
          aanvragerInkomstenPeriodeDerde?.wgaUitkeringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.wiaExcedentVerzekeringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.wiaExcedentVerzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
          partnerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.ivaUitkeringBedrag || 0
        ]) || 0) /
          12 -
          (normGegevens.gewenstBrutoInkomenBedrag || 0) / 12,
        0
      ) // min0
    },
    financieleGegevens: {
      toegestaneLast: normGegevens?.toegestaneLastBedrag || 0,
      werkelijkeBrutoLast: normGegevens?.werkelijkeLastBedrag || 0,
      tekortOpInkomen: Math.abs(
        normGegevens.tekortBenodigInkomenBedrag ? normGegevens.tekortBenodigInkomenBedrag / 12 : 0
      ),
      tekortOpInkomenTweede: Math.min(
        (optellen([
          aanvragerInkomstenPeriodeTweede?.wgaUitkeringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
          partnerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
          aanvragerInkomstenPeriodeTweede?.ivaUitkeringBedrag || 0
        ]) || 0) /
          12 -
          (normGegevens.benodigdInkomenBedrag || 0) / 12,
        0 //min0
      ),
      tekortOpInkomenDerde: Math.min(
        (optellen([
          aanvragerInkomstenPeriodeDerde?.wgaUitkeringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
          partnerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
          aanvragerInkomstenPeriodeDerde?.ivaUitkeringBedrag || 0
        ]) || 0) /
          12 -
          (normGegevens.benodigdInkomenBedrag || 0) / 12,
        0
      ),
      tekortWerkelijk: normGegevens?.tekortBenodigInkomenBedrag || 0,
      tekortWerkelijkeBrutolast: Math.min(
        (normGegevens?.toegestaneLastBedrag || 0) - (normGegevens?.werkelijkeLastBedrag || 0),
        0
      ),
      maximaleHypotheekEerste: normGegevens?.maximaleHypotheekBedrag,
      maximaleHypotheekTweede: normGegevens?.maximaleHypotheekBedrag,
      maximaleHypotheekDerde: normGegevens?.maximaleHypotheekBedrag,
      hypotheekSaldo: normGegevens?.hypotheeksaldoBedrag,
      overschrijding: Math.min(
        (normGegevens?.maximaleHypotheekBedrag || 0) - (normGegevens?.hypotheeksaldoBedrag || 0),
        0
      ),
      benodigdInkomenHypotheek: normGegevens.benodigdInkomenBedrag ? normGegevens.benodigdInkomenBedrag / 12 : 0,
      maandelijksTekortHypotheekEerste:
        Math.min(
          (optellen([
            aanvragerInkomstenPeriodeEerst.wgaUitkeringBedrag,
            aanvragerInkomstenPeriodeEerst?.wgaGatVerzekeringBedrag || 0,
            aanvragerInkomstenPeriodeEerst?.wgaGatVerzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeEerst?.arbeidsongeschiktheidsverzekeringBedrag || 0,
            aanvragerInkomstenPeriodeEerst?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeEerst?.restInkomenBedrag || 0,
            partnerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
            aanvragerInkomstenPeriodeEerst?.ivaUitkeringBedrag || 0
          ]) || 0) /
            12 -
            (normGegevens.benodigdInkomenBedrag ? normGegevens.benodigdInkomenBedrag / 12 : 0)
        ) *
        (1 - (aanvragerInkomstenPeriodeEerst?.bruteringPercentage || 0) / 100), //totaal-inkomen - minimaalBenodigHypotheek,
      maandelijksTekortHypotheekTweede:
        Math.min(
          (optellen([
            aanvragerInkomstenPeriodeTweede?.wgaUitkeringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.wgaGatVerzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
            partnerInkomstenPeriodeTweede?.restInkomenBedrag || 0,
            aanvragerInkomstenPeriodeTweede?.ivaUitkeringBedrag || 0
          ]) || 0) /
            12 -
            (normGegevens.benodigdInkomenBedrag ? normGegevens.benodigdInkomenBedrag / 12 : 0)
        ) *
        (1 - (aanvragerInkomstenPeriodeTweede?.bruteringPercentage || 0) / 100),
      maandelijksTekortHypotheekDerde:
        Math.min(
          (optellen([
            aanvragerInkomstenPeriodeDerde?.wgaUitkeringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.wgaGatVerzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.arbeidsongeschiktheidsverzekeringBruteringBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
            partnerInkomstenPeriodeDerde?.restInkomenBedrag || 0,
            aanvragerInkomstenPeriodeDerde?.ivaUitkeringBedrag || 0
          ]) || 0) /
            12 -
            (normGegevens.benodigdInkomenBedrag ? normGegevens.benodigdInkomenBedrag / 12 : 0)
        ) *
        (1 - (aanvragerInkomstenPeriodeDerde?.bruteringPercentage || 0) / 100)
    },
    voetnoten: motiveringDl.toelichtingRegels || [],
    benodigdKapitaal: motiveringDl.benodigdKapitaal?.bedrag || null,
    benodigdKapitaalOmschrijving: motiveringDl.benodigdKapitaal?.omschrijving || ""
  };
}

export function mapMotiveringOverlijdenToInkomensanalyseProps(
  motiveringDl: MotiveringCompleetOutput,
  aanvragerKeuze: AanvragerKeuze
): OverlijdenProps {
  const {
    aanvragerInkomstenPeriodeEerst,
    partnerInkomstenPeriodeEerste,
    conclusiePeriodeEerste
  } = getInkomstenPeriodes(motiveringDl, aanvragerKeuze === AanvragerKeuze.Aanvrager2);
  const normGegevens = motiveringDl.normGegevens;
  const scenarioGegevens = motiveringDl.scenarioGegevens;

  // Gebruik de gegevens van de achterblijvende aanvrager
  const achterblijvendeAanvrager = partnerInkomstenPeriodeEerste || aanvragerInkomstenPeriodeEerst;

  if (
    !achterblijvendeAanvrager ||
    !normGegevens ||
    motiveringDl.totaalHuidigBrutoJaarinkomenBedrag === undefined ||
    !scenarioGegevens
  ) {
    return {} as OverlijdenProps;
  }

  return {
    nbiWeergeven: false,
    inkomensanalyseResultaten: motiveringDl.motiveringInkomensanalyse?.resultaten || [],
    motiveringInkomensanalyse: motiveringDl.motiveringInkomensanalyse,
    titel: "Inkomensanalyse bij overlijden",
    totaalHuidigBrutoJaarinkomenBedrag: motiveringDl.totaalHuidigBrutoJaarinkomenBedrag,
    conclusie: conclusiePeriodeEerste || "",
    nbi: motiveringDl.motiveringInkomensanalyse?.nbiOverzichten?.["1"]?.jaren || [],
    nbiVoetnoot: motiveringDl.motiveringInkomensanalyse?.nbiOverzicht?.voetnoot?.voetnoot || "",
    controleInkomenWeergeven: false,
    inkomensData: {
      naamPersoon:
        aanvragerKeuze === AanvragerKeuze.Aanvrager2
          ? motiveringDl.klantNaamPartner || "Partner"
          : motiveringDl.klantNaamAanvrager || "Aanvrager",
      werkgeversPensioen: achterblijvendeAanvrager?.werkgeverspensioenBedrag || 0,
      aowInkomen: achterblijvendeAanvrager?.aowUitkeringBedrag || 0,
      expirerendeLijfrente: achterblijvendeAanvrager?.expirerendeLijfrenteBedrag || 0,
      anwUitkeringBedrag: achterblijvendeAanvrager.anwUitkeringBedrag
        ? achterblijvendeAanvrager.anwUitkeringBedrag / 12
        : 0,
      anwHiaatVerzekeringBedrag: achterblijvendeAanvrager.anwHiaatVerzekeringBedrag
        ? achterblijvendeAanvrager.anwHiaatVerzekeringBedrag / 12
        : 0,
      anwHiaatVerzekeringBruteringBedrag: achterblijvendeAanvrager.anwHiaatVerzekeringBruteringBedrag
        ? achterblijvendeAanvrager.anwHiaatVerzekeringBruteringBedrag / 12
        : 0,
      nabestaandenpensioen: achterblijvendeAanvrager.nabestaandenpensioenBedrag,
      wezenpensioen: achterblijvendeAanvrager.wezenPensioenuitkeringBedrag,
      inkomensaanvullingBedrag: achterblijvendeAanvrager.aanvullingInkomenBedrag
        ? achterblijvendeAanvrager.aanvullingInkomenBedrag / 12
        : 0,
      inkomensaanvullingBruteringBedrag: achterblijvendeAanvrager.aanvullingInkomenBruteringBedrag
        ? achterblijvendeAanvrager.aanvullingInkomenBruteringBedrag / 12
        : 0,
      beleggingInkomen:
        (achterblijvendeAanvrager.beleggingenBedrag || 0) + (achterblijvendeAanvrager.beleggingenBruteringBedrag || 0),
      verhuurInkomen:
        (achterblijvendeAanvrager.verhuurBedrag || 0) + (achterblijvendeAanvrager.verhuurBruteringBedrag || 0),
      inkomenPartner: achterblijvendeAanvrager?.restInkomenBedrag || 0,
      inkomenOverig:
        (achterblijvendeAanvrager?.inkomstenOverigBedrag || 0) +
        (achterblijvendeAanvrager?.inkomstenOverigBruteringBedrag || 0),
      totaalInkomen:
        (optellen([
          achterblijvendeAanvrager?.werkgeverspensioenBedrag || 0,
          achterblijvendeAanvrager?.aowUitkeringBedrag || 0,
          achterblijvendeAanvrager?.expirerendeLijfrenteBedrag || 0,
          achterblijvendeAanvrager?.anwUitkeringBedrag || 0,
          achterblijvendeAanvrager?.nabestaandenpensioenBedrag || 0,
          achterblijvendeAanvrager?.beleggingenBedrag || 0,
          achterblijvendeAanvrager?.beleggingenBruteringBedrag || 0,
          achterblijvendeAanvrager?.verhuurBedrag || 0,
          achterblijvendeAanvrager?.verhuurBruteringBedrag || 0,
          achterblijvendeAanvrager?.aanvullingInkomenBedrag || 0,
          achterblijvendeAanvrager?.aanvullingInkomenBruteringBedrag || 0,
          achterblijvendeAanvrager?.wezenPensioenuitkeringBedrag || 0,
          achterblijvendeAanvrager?.restInkomenBedrag || 0,
          achterblijvendeAanvrager?.inkomstenOverigBedrag || 0,
          achterblijvendeAanvrager?.inkomstenOverigBruteringBedrag || 0
        ]) || 0) / 12,
      inkomensverlies: Math.max(
        ((motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 0) -
          (achterblijvendeAanvrager.totaalBrutoInkomenBedrag || 0)) /
          12,
        0
      ),
      werkenNaOverlijdenPartnerPercentage: scenarioGegevens?.werkenNaOverlijdenPartnerPercentage || 0
    },
    jaarlijkseAnalyse: {
      gewenstInkomen: normGegevens?.gewenstBrutoInkomenBedrag,
      gewenstInkomenPercentage:
        ((normGegevens.gewenstBrutoInkomenBedrag || 1) / (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 1)) * 100,
      maandelijksTekort: Math.max(
        (normGegevens?.gewenstBrutoInkomenBedrag ? (normGegevens?.gewenstBrutoInkomenBedrag || 0) / 12 : 0) -
          (optellen([
            achterblijvendeAanvrager?.anwUitkeringBedrag || 0,
            achterblijvendeAanvrager?.nabestaandenpensioenBedrag || 0,
            achterblijvendeAanvrager?.aanvullingInkomenBedrag || 0,
            achterblijvendeAanvrager?.aanvullingInkomenBruteringBedrag || 0,
            achterblijvendeAanvrager?.wezenPensioenuitkeringBedrag || 0,
            achterblijvendeAanvrager?.restInkomenBedrag || 0
          ]) || 0) /
            12,
        0
      )
    },
    financieleGegevens: {
      benodigdInkomenHypotheek: normGegevens.benodigdInkomenBedrag ? normGegevens.benodigdInkomenBedrag / 12 : 0,
      tekortOpInkomen: normGegevens.tekortBenodigInkomenBedrag ? normGegevens.tekortBenodigInkomenBedrag / 12 : 0,
      maximaleHypotheek: normGegevens?.maximaleHypotheekBedrag || null,
      hypotheekSaldo: normGegevens?.hypotheeksaldoBedrag || null,
      overschrijding: Math.min(
        (normGegevens?.maximaleHypotheekBedrag || 0) - (normGegevens?.hypotheeksaldoBedrag || 0),
        0
      ),
      toegestaneLast: normGegevens?.toegestaneLastBedrag || null,
      werkelijkeBrutoLast: normGegevens?.werkelijkeLastBedrag || null,
      tekortWerkelijkeBrutolast: (normGegevens?.toegestaneLastBedrag || 0) - (normGegevens?.werkelijkeLastBedrag || 0)
    },
    voetnoten: motiveringDl.toelichtingRegels || [],
    benodigdKapitaal: motiveringDl.benodigdKapitaal?.bedrag || null,
    benodigdKapitaalOmschrijving: motiveringDl.benodigdKapitaal?.omschrijving || ""
  };
}

export const mapMotiveringPensioenToInkomensanalyseProps = (
  motiveringDl: MotiveringCompleetOutput,
  aanvragerKeuze: AanvragerKeuze
): PensioenDataProps => {
  const {
    aanvragerInkomstenPeriodeEerst,
    conclusiePeriodeEerste,
    partnerInkomstenPeriodeEerste
  } = getInkomstenPeriodes(motiveringDl, aanvragerKeuze === AanvragerKeuze.Aanvrager2);
  const normGegevens = motiveringDl?.normGegevens;

  if (
    motiveringDl.totaalHuidigBrutoJaarinkomenBedrag === undefined ||
    motiveringDl.totaalBrutoInkomenBedrag === undefined ||
    !aanvragerInkomstenPeriodeEerst ||
    !normGegevens
  ) {
    throw Error("Essential data not found on motiveringDl for Pensioen mapping");
  }

  return {
    nbiWeergeven: false,
    inkomensanalyseResultaten: motiveringDl.motiveringInkomensanalyse?.resultaten || [],
    titel: "",
    totaalHuidigBrutoJaarinkomenBedrag: motiveringDl.totaalHuidigBrutoJaarinkomenBedrag,
    motiveringInkomensanalyse: motiveringDl.motiveringInkomensanalyse,
    conclusie: conclusiePeriodeEerste || "",
    nbi: motiveringDl.motiveringInkomensanalyse?.nbiOverzichten?.["1"]?.jaren || [],
    nbiVoetnoot: motiveringDl.motiveringInkomensanalyse?.nbiOverzicht?.voetnoot?.voetnoot || "",
    inkomensData: {
      naamPersoon:
        aanvragerKeuze === AanvragerKeuze.Aanvrager2
          ? motiveringDl.klantNaamPartner || "Partner"
          : motiveringDl.klantNaamAanvrager || "Aanvrager",
      restinkomenAanvrager:
        (aanvragerInkomstenPeriodeEerst?.aowUitkeringBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.werkgeverspensioenBedrag || 0),
      restinkomenPartner: partnerInkomstenPeriodeEerste?.restInkomenBedrag || null,
      beleggingInkomenAanvrager:
        (aanvragerInkomstenPeriodeEerst?.beleggingenBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.beleggingenBruteringBedrag || 0),
      beleggingInkomenPartner:
        (partnerInkomstenPeriodeEerste?.beleggingenBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.beleggingenBruteringBedrag || 0),
      verhuurInkomenAanvrager:
        (aanvragerInkomstenPeriodeEerst?.verhuurBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.verhuurBruteringBedrag || 0),
      verhuurInkomenPartner:
        (partnerInkomstenPeriodeEerste?.verhuurBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.verhuurBruteringBedrag || 0),
      totaalInkomen:
        (aanvragerInkomstenPeriodeEerst?.restInkomenBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.aowUitkeringBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.aowUitkeringBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.beleggingenBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.beleggingenBruteringBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.beleggingenBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.beleggingenBruteringBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.verhuurBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.verhuurBruteringBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.verhuurBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.verhuurBruteringBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.expirerendeLijfrenteBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.expirerendeLijfrenteBedrag || 0) +
        (aanvragerInkomstenPeriodeEerst?.werkgeverspensioenBedrag || 0) +
        (partnerInkomstenPeriodeEerste?.werkgeverspensioenBedrag || 0),
      inkomensverlies:
        motiveringDl.totaalHuidigBrutoJaarinkomenBedrag / 12 - motiveringDl.totaalBrutoInkomenBedrag / 12,
      werkgeversPensioenAanvrager: aanvragerInkomstenPeriodeEerst?.werkgeverspensioenBedrag || 0,
      werkgeversPensioenPartner: partnerInkomstenPeriodeEerste?.werkgeverspensioenBedrag || 0,
      aowInkomenAanvrager: aanvragerInkomstenPeriodeEerst?.aowUitkeringBedrag || 0,
      aowInkomenPartner: partnerInkomstenPeriodeEerste?.aowUitkeringBedrag || 0,
      expirerendeLijfrenteAanvrager: aanvragerInkomstenPeriodeEerst?.expirerendeLijfrenteBedrag || 0,
      expirerendeLijfrentePartner: partnerInkomstenPeriodeEerste?.expirerendeLijfrenteBedrag || 0
    },
    financieleGegevens: {
      huidigInkomen70Procent: (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag / 12) * 0.7,
      toegestaneLast: normGegevens?.toegestaneLastBedrag || null,
      werkelijkeBrutoLast: normGegevens?.werkelijkeLastBedrag || null,
      tekortWerkelijkeBrutolast: (normGegevens?.toegestaneLastBedrag || 0) - (normGegevens?.werkelijkeLastBedrag || 0),
      tekortWerkelijk: normGegevens?.tekortBenodigInkomenBedrag || null,
      maximaleHypotheek: normGegevens?.maximaleHypotheekBedrag || null,
      hypotheekSaldo: normGegevens?.hypotheeksaldoBedrag || null,
      overschrijding: Math.min(
        (normGegevens?.maximaleHypotheekBedrag || 0) - (normGegevens?.hypotheeksaldoBedrag || 0),
        0
      ),
      benodigdInkomenHypotheek: normGegevens?.benodigdInkomenBedrag ? normGegevens.benodigdInkomenBedrag / 12 : 0,
      tekortOpInkomen: normGegevens?.tekortBenodigInkomenBedrag ? normGegevens.tekortBenodigInkomenBedrag / 12 : 0
    },
    jaarlijkseAnalyse: {
      gewenstInkomen: normGegevens?.gewenstBrutoInkomenBedrag || 0,
      gewenstInkomenPercentage:
        ((normGegevens?.gewenstBrutoInkomenBedrag || 1) / (motiveringDl.totaalHuidigBrutoJaarinkomenBedrag || 1)) * 100,
      maandelijksTekort: Math.min(
        ((aanvragerInkomstenPeriodeEerst?.restInkomenBedrag || 0) +
          (partnerInkomstenPeriodeEerste?.restInkomenBedrag || 0) +
          (aanvragerInkomstenPeriodeEerst?.aowUitkeringBedrag || 0) +
          (partnerInkomstenPeriodeEerste?.aowUitkeringBedrag || 0) +
          (aanvragerInkomstenPeriodeEerst?.werkgeverspensioenBedrag || 0) +
          (partnerInkomstenPeriodeEerste?.werkgeverspensioenBedrag || 0) -
          (normGegevens?.gewenstBrutoInkomenBedrag || 0)) /
          12,
        0
      )
    },
    voetnoten: motiveringDl.toelichtingRegels || [],
    benodigdKapitaal: motiveringDl.benodigdKapitaal?.bedrag || 0,
    benodigdKapitaalOmschrijving: motiveringDl.benodigdKapitaal?.omschrijving || ""
  };
};
